import * as React from 'react'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import Button from '@app.components/Button'
import Modal, { IFModalProps } from 'app.components/Modal/Modal'
import { mobileBreakPoint } from 'app.styled/media'

type DesktopOnlyModalProps = IFModalProps

const DesktopOnlyModal: React.FC<DesktopOnlyModalProps> = ({
  onClose,
  ...props
}) => {
  return (
    <Modal onClose={onClose} {...props}>
      <StyledWrapper>
        <div className="close-btn" onClick={onClose}>
          <Close />
        </div>
        <div className="modal-sub-title">
          PC에서만 이용 가능한 기능입니다.
          <br />
          PC에서 이용해주세요.
        </div>
        <div className="btn-list">
          <Button className="btn" onClick={onClose}>
            확인
          </Button>
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default DesktopOnlyModal

const StyledWrapper = styled.div`
  width: 100%;
  max-width: 450px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;

  .close-btn {
    align-self: flex-end;
    color: #999999;
    cursor: pointer;
  }
  .modal-sub-title {
    font-size: 18px;
    margin: 20px 0 30px;
    width: 100%;
    text-align: center;
  }
  .btn-list {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    .btn {
      font-size: 16px;
      padding: 13px 30px;
      &.cancle {
        background-color: #bbbbbb;
      }
    }
  }
  ${mobileBreakPoint} {
    max-width: 350px;
  }
`
